import Insured from '@/modules/common/common/models/APP/Insured'
import HealthHiringInsuredHealthSituation from '@/modules/health/hiring/models/APP/HealthHiringInsuredHealthSituation'
import HealthHiringInsuredMedicalSituation from '@/modules/health/hiring/models/APP/HealthHiringInsuredMedicalSituation'

export default class ForeignHealthInsured extends Insured {
  /** (Boolean): Indica si el asegurado tiene una póliza en otra compañía. */
  hasPolicyInOtherCompany: boolean
  /** Lista de coberturas opcionales asociadas al asegurado en caso que aplique al producto. */
  medicalSituation = new HealthHiringInsuredMedicalSituation()
  healthSituation = new HealthHiringInsuredHealthSituation()
  studentSituation: string | null = null

  constructor(data: any = {}) {
    super(data)
    
    this.hasPolicyInOtherCompany = data.hasPolicyInOtherCompany
    this.medicalSituation = new HealthHiringInsuredMedicalSituation(data.medicalSituation)
    this.healthSituation = new HealthHiringInsuredHealthSituation(data.healthSituation)
    this.studentSituation = data.studentSituation ?? null
  }
}
